var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StandardSearchPageView',{ref:"tableWrap",attrs:{"rowKey":"id","columns":_vm.columns,"queryParams":_vm.queryParams,"request-promise":_vm.loadList,"enableSearch":false},scopedSlots:_vm._u([{key:"auditStatus",fn:function(ref){
var record = ref.record;
return [_vm._v(" "+_vm._s(record.platformStatusDesc || '-')+" ")]}},{key:"templateType",fn:function(ref){
var record = ref.record;
return [_vm._v(" "+_vm._s(record.templateTypeDesc || '-')+" ")]}},{key:"enableStatus",fn:function(ref){
var record = ref.record;
return [_vm._v(" "+_vm._s(_vm.isEnabled(record) ? '启用' : '禁用')+" ")]}},{key:"action",fn:function(ref){
var record = ref.record;
return [_c('a',{on:{"click":function($event){return _vm.toggleStatus(record)}}},[_vm._v(" "+_vm._s(_vm.isEnabled(record) ? '禁用' : '启用')+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }